import React from 'react';
import './AdCard.css';

const AdCard = ({ ad }) => {
  return (
    <div className="post-card ad-card">
      {/* Sponsored Badge */}
      <span className="ad-sponsored-badge">Sponsored</span>

      {/* Left Icon Panel */}
      <div className="post-icon-panel ad-type">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 3v18h18V3H3zm16 16H5V5h14v14zM7 12h2v5H7v-5zm4-3h2v8h-2V9zm4-2h2v10h-2V7z"/>
        </svg>
        <span className="icon-label">Ad</span>
      </div>

      {/* Right Content Panel */}
      <div className="post-content">
        {/* Title Row */}
        <div className="post-title-row">
          <div className="post-title-info">
            <h3 className="post-title">{ad.title}</h3>
          </div>
        </div>

        {/* Description */}
        {ad.description && (
          <p className="post-description ad-description">{ad.description}</p>
        )}

        {/* Link */}
        {ad.link_url && (
          <div className="ad-link-row">
            <a
              href={ad.link_url}
              target="_blank"
              rel="noopener noreferrer"
              className="ad-learn-more"
            >
              Learn More
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                <path fillRule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdCard;
